import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';

export function MultipleSelectAutoComplete({
    data,
    values,
    handleChange,
    label = 'Seleccione...',
    name = '',
    required = false,
    error = false,
    errorText = 'Campo requerido'
}) {
    const theme = useTheme();
    return (
        <>
            {data.length > 0 && values ? (
                <FormControl fullWidth size="small" error={error}>
                    <Autocomplete
                        multiple
                        id="multiple-autocomplete"
                        options={data}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.key}
                        value={data.filter((item) => values.includes(item.value))}
                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    name: name,
                                    value: newValue.map((item) => item.value),
                                }
                            });
                        }}
                        renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                                <Chip
                                    variant="filled"
                                    color="primary"
                                    label={option.key}
                                    {...getTagProps({ index })}
                                    size="small"
                                />
                            ))
                        }
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <span
                                    style={{
                                        fontWeight: selected ? 600 : 400,
                                        color: selected ? theme.palette.primary.main : 'inherit',
                                    }}
                                >
                                    {option.key}
                                </span>
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={label}
                                placeholder="Escribe para buscar"
                                required={required}
                                error={error}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                    {error && errorText && <FormHelperText>{errorText}</FormHelperText>}
                </FormControl>
            ) : (
                <Autocomplete
                    multiple
                    options={[]}
                    renderInput={(params) => (
                        <TextField {...params} label={label} />
                    )}
                />
            )}
        </>
    );
}
